module.exports = __webpack_public_path__ + "static/media/autzucalendar.40555615.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogsPreselected/autzucalendar.png
// module id = 2204
// module chunks = 0